import { type FieldError, type FieldErrors } from 'react-hook-form'
import { scopedTranslation } from '@utils/I18n'
import _ from 'lodash'

const t = scopedTranslation('components.text_input')

export const useFormField = (name: string, errors: FieldErrors | undefined, required?: boolean, description?: string) => {
  const fieldError = _.get(errors, name) as FieldError | undefined
  const errorId = `${name}.error`
  const descriptionId = `${name}.description`

  const describedByIds: string[] = []
  if (description) {
    describedByIds.push(descriptionId)
  }
  if (fieldError) {
    describedByIds.push(errorId)
  }
  const ariaDescribedBy = describedByIds.length > 0 ? describedByIds.join(' ') : undefined

  const requiredText = required ? t('required') : undefined

  return {
    fieldError,
    errorId,
    descriptionId,
    ariaDescribedBy,
    requiredText,
    ariaInvalid: !!fieldError
  }
} 